<template>
    <loading-block v-if="dataIsLoading"></loading-block>
    <div class="cont" v-else>
        <div>
            <uni-loading-button style="margin-right: 1rem;" :is-disable="exportLoading" @click.native="exportToExcel"
                                class="uni-button button-secondary" text="Exporter (Excel)"></uni-loading-button>
            <uni-loading-button :is-disable="exportLoading" @click.native="exportData"
                                class="uni-button button-secondary" text="Exporter (Autres logiciels)"></uni-loading-button>
<!--            <uni-loading-button :is-disable="exportLoading" @click.native="exportEmail"-->
<!--                                class="uni-button button-secondary" text="Emails"></uni-loading-button>-->
        </div>
        <section>
            <div>
                <div>
                    <h1>Filtres</h1>
                    <uni-circular-loader v-if="filterIsLoading"></uni-circular-loader>
                </div>


                <h3>Certificat médical</h3>
                <div class="pill-container">
                    <pill @click.native="toggleCertificate(false)" :reverse="certificateButton === false"
                          bg-color="pill-danger">Manquant
                    </pill>
                    <pill @click.native="toggleCertificate(null)" :reverse="certificateButton === null"
                          bg-color="pill-warning">À
                        valider
                    </pill>
                    <pill @click.native="toggleCertificate(true)" :reverse="certificateButton === true"
                          bg-color="pill-success">Validé
                    </pill>
                </div>
                <h3>Statut du paiement</h3>
                <div class="pill-container">
                    <pill @click.native="togglePaiement(false)" :reverse="paymentButton === false"
                          bg-color="pill-danger">À
                        Payer
                    </pill>
                    <pill @click.native="togglePaiement(true)" :reverse="paymentButton === true"
                          bg-color="pill-success">
                        Réceptionné
                    </pill>
                </div>
                <h3>Type de paiement</h3>
                <div class="pill-container">
                    <pill @click.native="toggleType('Chèque')" :reverse="typeButton === 'Chèque'">Chèque
                    </pill>
                    <pill @click.native="toggleType('Éspèces')" :reverse="typeButton === 'Éspèces'">
                        Espèces
                    </pill>
                    <pill @click.native="toggleType('Virement')" :reverse="typeButton === 'Virement'">
                        Virement
                    </pill>
                </div>
                <h3>Ordre de virement</h3>
                <div class="pill-container">
                    <pill @click.native="toggleTransfer(true)" :reverse="transferButton === true">Enregistré
                    </pill>
                    <pill @click.native="toggleTransfer(false)" :reverse="transferButton === false">
                        Manquant
                    </pill>
                </div>
                <h3>Trimestre</h3>
                <div class="pill-container">
                    <pill @click.native="toggleQuarter(1)" :reverse="quarterButton === 1">T1</pill>
                    <pill @click.native="toggleQuarter(2)" :reverse="quarterButton === 2">T2</pill>
                    <pill @click.native="toggleQuarter(3)" :reverse="quarterButton === 3">T3</pill>
                </div>
                <div class="courses">
                    <h3>Cours</h3>
                    <ul v-for="category in course_categories">
                        <li>
                            <uni-input-checkbox :id="'category' + category.id" :label="category.name">
                                <input @change="filterCourseCategory($event, category.id)" type="checkbox"
                                       :value="category.id"
                                       :id="'category' + category.id">
                            </uni-input-checkbox>
                        </li>
                        <li class="check-parent">
                            <ul>
                                <li v-for="course in category.courses">
                                    <uni-input-checkbox :id="'course-' +course.id" :label="course.name">
                                        <input @change="filterCourse($event)" type="checkbox"
                                               :value="course.id"
                                               :id="'course-' +course.id">
                                    </uni-input-checkbox>

                                </li>
                            </ul>
                        </li>

                    </ul>
                </div>
            </div>
            <div>
                <div class="header">
                    <h1>Danseurs</h1>
                    <p>{{currentUsers.length}} / {{users.length}}</p>
                </div>
                <div v-if="currentUsers.length > 0">
                    <user-inline :list="true" v-for="user in currentUsers"
                                 :user="user" :quarter="quarterButton"></user-inline>
                </div>
                <div v-else>
                    <p>Aucun résultat ne correspond</p>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import UserInline from "../../components/b-patterns/userInline";
    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import Pill from "../../components/a-elements/pill";
    import UniInputCheckbox from "../../components/a-elements/UniInputCheckbox";
    import UniCircularLoader from "../../components/a-elements/UniCircularLoader";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

    import zipcelx from 'zipcelx'
    import {mapGetters} from "vuex";

    export default {
        name: "index",
        components: {UniLoadingButton, UniCircularLoader, UniInputCheckbox, Pill, LoadingBlock, UserInline},
        computed: {
          ...mapGetters(['currentYear'])
        },
        data() {
            return {
                exportLoading: false,

                transferUsers: [
                    {
                        status: true,
                        users: []
                    },
                    {
                        status: false,
                        users: []
                    }
                ],

                // certificats
                certUsers: [
                    {
                        status: true,
                        users: []
                    },
                    {
                        status: null,
                        users: []
                    },
                    {
                        status: false,
                        users: []
                    },

                ],

                paymentUsers: [
                    {
                        status: true,
                        users: []
                    },
                    {
                        status: null,
                        users: []
                    },
                    {
                        status: false,
                        users: []
                    },
                ],

                typeUsers: [
                    {
                        status: 'Chèque', // chèque
                        users: []
                    },
                    {
                        status: 'Éspèces', // espèces
                        users: []
                    },
                    {
                        status: 'Virement', // virement
                        users: []
                    },
                ],

                quarter: [
                    {
                        status: 'T1',
                        users: [],
                    }
                ],

                // Users par cours
                coursesUsers: [],

                // Users affichés
                currentUsers: [],

                // tous les Users
                users: [],

                // Les fitres actuellement utilisés
                currentFilters: {
                    // certificat: {status: true},
                    // payment: {status: true},
                    // type: {status: 'Chèque'},
                    courses: []
                },

                emailUsers: [],

                course_categories: [],
                dataIsLoading: true,
                filterIsLoading: false,
                certificateButton: '',
                paymentButton: '',
                typeButton: '',
                transferButton: '',
                quarterButton: 0,

            }
        },
        methods: {

            // FONCTIONS UTILES


            /**
             *
             * Affiche le loader pendant l'éxecution du filtre
             *
             */
            displayLoader() {
                // TODO: Faire fonctionner le loader
                this.filterIsLoading = true
            },

            /**
             *
             * Cache le loader une fois que le filtre a fini de s'éxecuter
             *
             */
            hideLoader() {
                this.filterIsLoading = false
            },

            /**
             *
             * Permet de rafraichir le tableau des users
             *
             */
            reloadCurrentUsers() {
                this.currentUsers = this.users.filter(u => this.checkUser(u)).sort(this.dynamicSort("name"))
                this.hideLoader()
            },

            /**
             * Function to sort alphabetically an array of objects by some specific key.
             *
             * @param {String} property Key of the object to sort.
             */
            dynamicSort(property) {
                let sortOrder = 1;

                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }

                return function (a, b) {
                    if (sortOrder === -1) {
                        return b[property].localeCompare(a[property]);
                    } else {
                        return a[property].localeCompare(b[property]);
                    }
                }
            },

            /**
             *
             * Convertit le tableau d'users en format CSV
             *
             **/
            convertArrayOfObjectsToCSV(data) {
                let result, ctr, keys, columnDelimiter, lineDelimiter;


                columnDelimiter = ',';
                lineDelimiter = '\n';

                keys = Object.keys(data[0]);

                result = '';
                result += keys.join(columnDelimiter);
                result += lineDelimiter;

                data.forEach(function (item) {
                    ctr = 0;
                    keys.forEach(function (key) {
                        if (ctr > 0) result += columnDelimiter;

                        result += item[key];
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            },

            /**
             *
             * Export le tableau courant des danseurs au format XLSX et le télécharge
             *
             **/
            exportToExcel() {
                let excel = {
                    filename: 'export-richendanse',
                    sheet: {
                        data: [
                            [
                                {
                                    value: 'Nom'
                                },
                                {
                                    value: 'Prénom'
                                },
                                {
                                    value: 'Date de naissance'
                                },
                                {
                                value: 'Téléphone'
                               }, 
                                {
                                    value: 'Age'
                                },
                                {
                                    value: 'Rue'
                                },
                                {
                                    value: 'Code Postal'
                                },
                                {
                                    value: 'Ville'
                                }
                            ]
                        ]
                    }
                }

                this.currentUsers.forEach(user => {
                    excel.sheet.data.push([
                        {
                            value: user.name
                        },
                        {
                            value: user.firstname
                        },
                        {
                            value: this.$birthDate(user.birth_date)
                        },
                        {
                            value: user.tel
                        },
                        {
                            value: this.$getAge(user.birth_date)
                        },
                        {
                            value: user.street.replace(',', ' ')
                        },
                        {
                            value: user.postal_code
                        },
                        {
                            value: user.city
                        }
                    ])
                })

                zipcelx(excel)
            },

            /**
             *
             * Export le tableau courant des danseurs au format CSV et le télécharge
             *
             **/
            exportToCsv() {
                let formattedArray = []
                // formater le tableau pour l'exporter

                this.currentUsers.forEach(user => {
                    let formatted = {
                        'Nom': user.name,
                        'Prénom': user.firstname,
                        'Date de naissance': this.$birthDate(user.birth_date),
                        'Téléphone': user.tel,
                        'Age': this.$getAge(user.birth_date),
                        'Rue': user.street.replace(',', ' '),
                        'Code postal': user.postal_code,
                        'Ville': user.city,

                    }

                    formattedArray.push(formatted)
                })

                let data, filename, link;
                let csv = this.convertArrayOfObjectsToCSV(formattedArray);
                if (csv == null) return;

                filename = 'export-richendanse.csv';

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }
                data = encodeURI(csv);

                link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();

            },

            exportToEmail() {
                let formattedArray = []
                // formater le tableau pour l'exporter

                this.emailUsers.forEach(user => {
                    let formatted = {
                        'EMAIL': user.email,
                        'NAME': user.name,
                        'FIRSTNAME': user.firstname

                    }

                    formattedArray.push(formatted)
                })

                let data, filename, link;
                let csv = this.convertArrayOfObjectsToCSV(formattedArray);
                if (csv == null) return;

                filename = 'export-richendanse-email.csv';

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }
                data = encodeURI(csv);

                link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();

            },

            // ===========================


            // INITIALISATION DES TABLEAUX
            /**
             * @param users {Array}
             * @return Array
             */
            initCertificateArray(users) {
                users.forEach(user => {
                    if (user.medical_certificate && user.medical_certificate.year) {
                        this.certUsers.find(x => x.status === true).users.push(user)
                    } else if (user.medical_certificate && !user.medical_certificate.year) {
                        this.certUsers.find(x => x.status === null).users.push(user)
                    } else {
                        this.certUsers.find(x => x.status === false).users.push(user)
                    }
                })

            },

            /**
             * @param users {Array}
             * @param status {Boolean}
             * @return Array
             */
            initTransferArray(users) {
                let yes = [], no = []

                users.forEach(u => {
                    if (u.payments.length !== 0) {
                        if (u.payments.length === 1) {
                            if (u.payments[0].payment_type === 'Virement' && u.payments[0].attachment) {
                                yes.push(u)
                            } else if (u.payments[0].payment_type === 'Virement' && !u.payments[0].attachment) {
                                no.push(u)
                            }

                        } else {
                            if (u.payments[this.quarterButton - 1].payment_type === 'Virement' && u.payments[this.quarterButton - 1].attachment) {
                                yes.push(u)
                            } else if (u.payments[this.quarterButton - 1].payment_type === 'Virement' && !u.payments[this.quarterButton - 1].attachment) {
                                no.push(u)
                            }

                        }
                    } else {
                        no.push(u)

                    }
                })
                this.transferUsers.find(x => x.status).users = yes
                this.transferUsers.find(x => !x.status).users = no

            },

            /**
             * @param users {Array}
             * @param status {Boolean}
             * @return Array
             */
            initPaymentArray(users, status) {
                let us = []
                users.forEach(u => {
                    if (u.payments.length !== 0) {
                        if (u.payments.length === 1) {
                            if (u.payments[0].status === status) {
                                us.push(u)
                            }

                        } else {
                            if (u.payments[this.quarterButton - 1].status === status) {
                                us.push(u)
                            }

                        }
                    } else {
                        if (status === false) {
                            us.push(u)
                        }
                    }


                })
                return us
            },


            /**
             * @param users {Array}
             * @param status {String}
             * @return Array
             */
            initTypeArray(users, status) {
                let us = []
                users.forEach(u => {
                    if (u.payments.length !== 0) {
                        if (u.payments.length === 1) {

                            if (u.payments[0].payment_type === status) {
                                us.push(u)
                            }

                        } else {
                            if (u.payments[this.quarterButton - 1].payment_type === status) {
                                us.push(u)
                            }

                        }
                    }
                })
                return us
            },


            // =================================================


            // CHECK DES FILTERS


            /**
             *
             * Permet de savoir si un utilisateur a déja été filtré
             *
             * @param user {Object}
             * @returns {boolean}
             */
            checkUser(user) {
                let filters = this.currentFilters
                // Si il y a des filtres
                if (this.hasFilters()) {
                    // compte les erreurs de filtres
                    let errors = 0

                    // Si un filtre certificat a été appliqué
                    if (filters.certificate) {
                        if (filters.certificate.status) {
                            if (user.medical_certificate && user.medical_certificate.year) {
                            } else {
                                errors++
                            }
                        } else if (filters.certificate.status === null) {
                            if (user.medical_certificate && !user.medical_certificate.year) {
                            } else {
                                errors++
                            }

                        } else {
                            if (user.medical_certificate) {
                                errors++
                            }
                        }
                    }

                    // Si un filtre paiement a été appliqué
                    if (filters.payment) {
                        // Si le danseur n'a pas de paiement
                        if (user.payments.length === 0) {
                            if (filters.payment.status !== false) {
                                errors++
                            }
                        } else {
                            // si le danseur a payé toute l'année d'un coup
                            if (user.payments.length === 1) {
                                if (user.payments[0].status !== filters.payment.status) {
                                    errors++
                                }
                            } else {
                                // si le danseur a payé en 3 fois
                                if (user.payments[this.quarterButton - 1].status !== filters.payment.status) {
                                    errors++
                                }

                            }
                        }
                    }

                    // si un filtre sur le type de paiement
                    if (filters.type) {
                        if (user.payments.length === 0) {
                            errors++
                        } else {
                            if (user.payments.length === 1) {
                                if (user.payments[0].payment_type !== filters.type.status) {
                                    errors++
                                }
                            } else {
                                if (user.payments[this.quarterButton - 1].payment_type !== filters.type.status) {
                                    errors++
                                }

                            }
                        }
                    }

                    // Si un filtre sur l'ordre de virement

                    if (filters.transfer) {
                        if (user.payments.length === 0) {
                            if (filters.transfer.status === true) {
                                errors++
                            }
                        } else {
                            if (user.payments.length === 1) {
                                if (filters.transfer.status === true) {
                                    if (user.payments[0].payment_type === 'Virement' && !user.payments[0].attachment) {
                                        errors++
                                    }
                                } else {
                                    if (user.payments[0].payment_type === 'Virement' && user.payments[0].attachment) {
                                        errors++
                                    }
                                }

                            } else {
                                if (filters.transfer.status === true) {
                                    if (user.payments[this.quarterButton - 1].payment_type === 'Virement' && !user.payments[this.quarterButton - 1].attachment) {
                                        errors++
                                    }
                                } else {
                                    if (user.payments[this.quarterButton - 1].payment_type === 'Virement' && user.payments[this.quarterButton - 1].attachment) {
                                        errors++
                                    }
                                }

                            }
                        }
                    }
                    // Si il y a un filtre sur les cours
                    if (filters.courses && filters.courses.length > 0) {

                        // ON Croise les cours filtrés avec les cours du user
                        let intersection = user.courses.filter(e => filters.courses.includes(e))

                        // s'il n'y a pas de match
                        if (intersection.length === 0) {
                            errors++
                        }
                    }


                    // SI aucune erreur, le test est passé
                    return errors === 0;
                } else {
                    return true
                }
            },

            /**
             *
             * Permet de savoir si des filtres sont présents
             *
             * @returns {Boolean}
             */
            hasFilters() {
                return Object.entries(this.currentFilters).length !== 0 && this.currentFilters.constructor === Object;
            },

            /**
             *
             * Détermine si le checkbox parent doit être checké, dans le cas où tous les enfants le sont
             *
             * @param input {HTMLElement}
             */
            checkParentCheckbox(input) {
                let children = [].slice.call(input.closest('.check-parent').firstElementChild.children)
                let checkbox = input.closest('.check-parent').previousElementSibling.querySelector('input')

                // SI tous les enfants sont checkés, on check le parent
                checkbox.checked = children.every(el => el.querySelector('input').checked);

            },


            // ==================================================


            // FONCTIONS DE TOGGLE DES BOUTONS DE FILTRE

            toggleCertificate(status) {
                if (status !== this.certificateButton) {
                    this.certificateButton = status
                } else {
                    this.certificateButton = ''
                }
                this.filterCertificate(status)

            },
            togglePaiement(status) {
                if (status !== this.paymentButton) {
                    this.paymentButton = status

                } else {
                    this.paymentButton = ''
                }
                this.filterPayment(status)
            },

            toggleType(status) {
                if (status !== this.typeButton) {
                    this.typeButton = status
                } else {
                    this.typeButton = ''
                }
                this.filterType(status)
            },

            toggleTransfer(status) {
                if (status !== this.transferButton) {
                    this.transferButton = status
                    this.typeButton = 'Virement'

                } else {
                    this.transferButton = ''
                    this.typeButton = ''
                }
                this.filterTransfer(status)
                this.filterType('Virement')
            },

            toggleQuarter(quarter) {
                if (quarter !== this.quarterButton) {
                    this.quarterButton = quarter
                    this.certificateButton = ''
                    this.paymentButton = ''
                    this.typeButton = ''
                    this.transferButton = ''

                    this.currentUsers = this.users

                }
            },

            // =====================================================


            // FONCTIONS DE FILTRE

            /**
             *
             * Retourne un nouveau tableau d'users en prenant en compte les filtres
             *
             * @param status {Boolean, String}
             * @param key {String} - Le nom de la clé dans le tableau des filtres
             * @returns Promise<Function>
             */
            getNewUsers(key, status) {
                return new Promise((resolve) => {
                    let users = []
                    if (this.hasFilters() && key in this.currentFilters) {
                        // Si le filtre est le même, on retire juste le filtre
                        if (this.currentFilters[key].status === status) {
                            delete this.currentFilters[key]
                            this.$nextTick(() => {
                                this.reloadCurrentUsers()
                            })
                        }
                        // sinon, on retire le filtre et on met le nouveau
                        else {
                            delete this.currentFilters[key]
                            this.$nextTick(() => {
                                resolve(users)
                            })
                        }
                    } else {
                        resolve(users)

                    }
                })
            },

            /**
             *
             * Permet de filtrer le tableau actuel en fonction du statut du certificat médical
             *
             * @param status {Boolean}
             */
            filterCertificate(status) {
                this.displayLoader()
                this.getNewUsers('certificate', status).then(users => {
                    users = this.users.concat(this.certUsers.find(x => x.status === status).users)
                    this.currentFilters.certificate = {status}
                    this.$nextTick(() => {
                        this.currentUsers = users.filter((item, index) => users.indexOf(item) !== index).filter(x => this.checkUser(x))
                        this.hideLoader()
                    })
                })

            },
            filterPayment(status) {
                this.displayLoader()
                this.getNewUsers('payment', status).then(users => {
                    users = this.users.concat(this.paymentUsers.find(x => x.status === status).users)
                    this.currentFilters.payment = {status}
                    this.$nextTick(() => {
                        this.currentUsers = users.filter((item, index) => users.indexOf(item) !== index).filter(x => this.checkUser(x))
                        this.hideLoader()
                    })
                })


            },

            filterType(status) {
                this.displayLoader()
                this.getNewUsers('type', status).then(users => {
                    users = this.users.concat(this.typeUsers.find(x => x.status === status).users)
                    this.currentFilters.type = {status}
                    this.$nextTick(() => {
                        this.currentUsers = users.filter((item, index) => users.indexOf(item) !== index).filter(x => this.checkUser(x))
                        this.hideLoader()
                    })
                })
            },


            filterTransfer(status) {
                this.displayLoader()
                this.getNewUsers('transfer', status).then(users => {
                    users = this.users.concat(this.transferUsers.find(x => x.status === status).users)
                    this.currentFilters.transfer = {status}
                    this.$nextTick(() => {
                        this.currentUsers = users.filter((item, index) => users.indexOf(item) !== index).filter(x => this.checkUser(x))
                        this.hideLoader()
                    })
                })


            },

            /**
             *
             * Permet de trigger le filtre sur tous les enfants
             *
             * @param e {Event}
             */
            filterCourseCategory(e) {
                this.displayLoader()
                let input
                let c
                let el = e.target
                let ids = []
                let checked = el.checked

                let children = [].slice.call(el.closest('li').nextElementSibling.firstElementChild.children)


                // Si on coche la case
                if (el.checked) {
                    children.forEach(child => {
                        input = child.querySelector('input')
                        if (!input.checked) {
                            ids.push(parseInt(input.value))
                            input.checked = true
                        }

                    })
                    // On ajoute les nouveaux ID
                    this.currentFilters.courses = this.currentFilters.courses.concat(ids)
                    this.$nextTick(() => {
                        this.reloadCurrentUsers()
                    })
                }
                // sinon
                else {
                    children.forEach(child => {
                        input = child.querySelector('input')
                        if (input.checked) {
                            ids.push(parseInt(input.value))
                            input.checked = false
                        }

                    })
                    // on enlève les ID
                    c = this.currentFilters.courses.filter(x => !ids.includes(x))

                    this.currentFilters.courses = c


                    this.$nextTick(() => {
                        this.reloadCurrentUsers()
                    })

                }


            },

            /**
             *
             * Permet d'ajouter l'ID du cours dans le tableau de filtres
             *
             * @param e {event}
             */
            filterCourse(e) {
                this.checkParentCheckbox(e.target)
                let value = parseInt(e.target.value)
                // si on coche la case
                if (e.target.checked) {
                    this.currentFilters.courses.push(value)
                    this.$nextTick(() => {
                        this.reloadCurrentUsers()
                    })
                }
                // sinon
                else {
                    let tab = this.currentFilters.courses.filter(c => c !== value)
                    this.currentFilters.courses = tab
                    this.$nextTick(() => {
                        this.reloadCurrentUsers()
                    })
                }
            },

            //====================================================

            //  AUTRES


            exportData() {
                this.exportLoading = true
                this.exportToCsv()
                this.exportLoading = false
            },

            exportEmail() {
                this.exportLoading = true
                this.exportToEmail()
                this.exportLoading = false
            },

        },
        created() {
            this.$adminGetFamilies()
                .then(data => {

                    let allUsers = []
                    data.families.forEach(family => {
                        if (!family.is_admin && family.users.some(el => el.is_dancer)) {
                            family.payments = family.payments.filter(el => el.year_id === this.currentYear.id)
                            family.users.forEach(user => {
                                if (user.is_dancer) {
                                    let courseUsers = user.course_users.filter(c => c.year_id === this.currentYear.id)
                                    if (courseUsers.length > 0) {
                                        let courses = []
                                        courseUsers.forEach(el => courses.push(el.course.id))
                                        user.payments = family.payments
                                        user.courses = courses
                                        allUsers.push(user)
                                    }

                                }

                            })
                        }
                    })
                    let emailUsers = []
                    data.families.forEach(family => {
                        if (!family.is_admin) {
                            family.users.forEach(user => {
                                if (user.email) {
                                    emailUsers.push(user)
                                }
                            })
                        }
                    })

                    this.emailUsers = emailUsers
                    this.quarterButton = this.$currentTrimestre()

                    // Users par ordre alphabétique
                    allUsers.sort(this.dynamicSort('name'))


                    data.courses.forEach(course_category => {
                        let el = {}
                        el.id = course_category.id
                        course_category.courses.forEach(course => {
                            el.courses = []
                            el.courses.push(course.id)
                        })
                        this.coursesUsers.push(el)
                    })

                    // Initialisation des certificats
                    this.initCertificateArray(allUsers)

                    // Initialisation des paiements

                    this.paymentUsers.find(x => x.status === true).users = this.initPaymentArray(allUsers, true)
                    this.paymentUsers.find(x => x.status === null).users = this.initPaymentArray(allUsers, null)
                    this.paymentUsers.find(x => x.status === false).users = this.initPaymentArray(allUsers, false)

                    // Initialisation des ordres de virement

                    this.initTransferArray(allUsers)

                    // Initialisation des Type de paiement

                    this.typeUsers.find(x => x.status === 'Chèque').users = this.initTypeArray(allUsers, 'Chèque')
                    this.typeUsers.find(x => x.status === 'Éspèces').users = this.initTypeArray(allUsers, 'Éspèces')
                    this.typeUsers.find(x => x.status === 'Virement').users = this.initTypeArray(allUsers, 'Virement')

                    //initialisation

                    this.users = allUsers
                    this.currentUsers = allUsers

                    this.course_categories = data.courses
                    this.users.sort(this.dynamicSort("name"))


                    this.dataIsLoading = false
                })
        }
    }
</script>

<style scoped lang="scss">

    .cont {
        > div:first-child {
            display: none;
        }
    }

    section {
        h1, h2 {
            margin-bottom: 1rem;
        }

        > div {
            margin-bottom: 1rem;
        }

        width: 100%;
        display: grid;
        grid-template-columns: 1fr;

        // filtres
        > div:first-child {

            > div:first-child {
                margin-bottom: 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                > h1 {
                    margin-bottom: 0;
                }

                > div {
                    width: 38px;
                }
            }

            > div.pill-container {
                width: 100%;
                margin: 12px 0 20px;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                justify-items: flex-start;

                > div {
                    width: 85px;
                }
            }
        }

        // danseurs
        > div:last-child {


            > .header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;

                > h1 {
                    margin: 0;
                }

                > p {
                    margin: 0;
                }

            }
        }
    }

    .courses {
        > ul {
            padding: 0;

            > li:first-child {
                font-weight: var(--font-weight-bold);
            }

            ul {
                padding: 0 20px;
            }
        }
    }

    @include screen-m {
        .cont {
            > div:first-child {
                display: flex;
                justify-content: flex-end;
            }
        }
        section {
            width: auto;
            grid-template-columns: 1fr 1fr;

            > div:first-child {
                padding: 0 16px;

                > div.pill-container {
                    width: 85%;
                }
            }

            > div:last-child {
                width: 800px;
            }
        }
    }

</style>
